import {PermissionResponse} from 'types/permissions';

export const mergePermissions = (
    ...permissions: PermissionResponse[]
): PermissionResponse => {
    for (const permission of permissions) {
        if (!permission.allowed) {
            return permission;
        }
    }
    return {
        allowed: true,
        failureReason: '',
    };
};
